import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PlusCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PlusCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PlusCircleOutlined.displayName = 'PlusCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(PlusCircleOutlined);